module.exports = __webpack_public_path__ + "45d02e7223ffabf402cd954444caa398.jpg";